<template>
  <!-- Error page-->
  <div id="app-container" style="height: calc(100vh - 40vh)">
    <!-- <b-row class="m-5">
      <b-col cols="4">
        <Select3 />
      </b-col>
    </b-row> -->
    <div class="app-root">
      <div class="jNVSgr">
        <div class="sTC0fR">
          <div class="r8H33s">
            <div class="AGjDmN">
              <div class="mb5u3c">
                <input
                  class=""
                  v-model="search"
                  type="text"
                  placeholder="Container, Booking, Bill of lading"
                  value=""
                />
              </div>
              <button
                type="button"
                @click="onSearch"
                class="WTsBDL DX8c49 en0Ha_ cewbX8"
              >
                <svg
                  width="20"
                  height="21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.987 16.987 14.79 13.79a.77.77 0 0 0-.545-.225h-.523a6.638 6.638 0 0 0 1.412-4.105A6.67 6.67 0 0 0 8.46 2.789a6.67 6.67 0 0 0-6.672 6.67 6.67 6.67 0 0 0 6.672 6.672 6.64 6.64 0 0 0 4.105-1.411v.522c0 .206.08.401.225.546l3.198 3.197a.767.767 0 0 0 1.087 0l.908-.907a.773.773 0 0 0 .003-1.09Zm-9.526-3.422A4.103 4.103 0 0 1 4.355 9.46a4.103 4.103 0 0 1 4.106-4.106 4.103 4.103 0 0 1 4.105 4.106 4.103 4.103 0 0 1-4.105 4.105Z"
                    fill="#fff"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div v-if="data" class="TWpeI4">
            <button type="button" class="u71Ug3">
              <svg
                width="20"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="ahH3dr"
              >
                <path
                  d="m8.929 14 3.901-3.929L8.901 6.17"
                  stroke="#000C37"
                  stroke-width="1.8"
                  stroke-linecap="round"
                ></path></svg
              >Back
            </button>
          </div>
          <div v-if="data" class="OZ_R4c">
            <input
              type="hidden"
              name="coord_from"
              value="[10.74895,106.79187]"
            /><input
              type="hidden"
              name="coord_to"
              value="[34.9414,127.69569]"
            />
            <div class="u4BptP W7yOGL">
              <div class="l2VQom">
                <div class="LeIfXT">{{ data.metadata.type }}</div>
                <div class="HMVUKi ZQiFhL">{{ data.metadata.number }}</div>
                <div class="s2XxtD">
                  <div class="PJhkJh">
                    <span>{{
                      !data.containers.size_type
                        ? data.containers.length
                        : `1 x ${data.containers.size_type}`
                    }}</span
                    ><svg
                      width="16"
                      height="16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="A7lpjs"
                    >
                      <path
                        d="M15.4 12.321h-.2V3.68h.2c.331 0 .6-.264.6-.59a.595.595 0 0 0-.6-.589H.6c-.331 0-.6.264-.6.59 0 .325.269.589.6.589h.2v8.642H.6c-.331 0-.6.264-.6.59 0 .325.269.589.6.589h14.8c.331 0 .6-.264.6-.59a.595.595 0 0 0-.6-.589Zm-1.4 0H2V3.68h12v8.642Zm-9.2-.785c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59Zm3.2 0c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59Zm3.2 0c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59Z"
                        fill="#28938D"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="w3nFNe rmT1SZ mNSdiZ ZwrEze">
                  {{ data.containers[data.containers.length - 1].status }}
                </div>
              </div>
              <div class="l2VQom CiXy7G">
                <span class="DB6l5z"
                  >{{ data.locations[0].name }},
                  {{ data.locations[0].country_code }}</span
                ><span class="DB6l5z"
                  >{{ data.locations[1].name }},
                  {{ data.locations[1].country_code }}</span
                >
              </div>
              <div class="u0XzuN pZIPN_ UyUQn0">
                <div class="hkD4KS"></div>
                <div class="NCFwvr Ocb7IW"></div>
                <div class="Do4DFw Ocb7IW" style="width: 100%"></div>
                <div class="hkD4KS gGZssi"></div>
              </div>
              <div class="l2VQom">
                <div class="esnUFS">
                  <div class="dqZ0ad">
                    ATD
                    {{
                      moment(data.route.pol.date, "YYYY-MM-DD HH:mm:ss").format(
                        "DD MMM YYYY"
                      )
                    }}
                  </div>
                  <div class="dqZ0ad">
                    ATA
                    {{
                      moment(data.route.pod.date, "YYYY-MM-DD HH:mm:ss").format(
                        "DD MMM YYYY"
                      )
                    }}
                  </div>
                </div>
                <div class="X6ICUu" style="max-width: 50%">
                  {{ data.metadata.sealine_name }}
                </div>
              </div>
              <div class="l2VQom HVrMNK">
                <div class="C4xvpO">
                  <div class="rASlAP oiKIxr">
                    <div class="vYiyP7">
                      <button
                        type="button"
                        @click="tab = 'Route'"
                        :class="`cF7936  ${tab == 'Route' && 'OKYBET'}`"
                      >
                        <span class="MyNzRc">Route</span></button
                      ><button
                        type="button"
                        @click="tab = 'Vessel'"
                        :class="`cF7936  ${tab == 'Vessel' && 'OKYBET'}`"
                      >
                        <span class="MyNzRc">Vessel</span></button
                      ><button
                        type="button"
                        @click="tab = 'Containers'"
                        :class="`cF7936  ${tab == 'Containers' && 'OKYBET'}`"
                      >
                        <span class="MyNzRc">Containers</span>
                      </button>
                    </div>
                  </div>
                  <!-- Route -->
                  <div v-if="tab == 'Route'" class="rASlAP nLoI_Y TQABDn">
                    <div class="VTkRN8 J_ckmS">
                      <div class="LAM7Hq">
                        <RouteSeaRates v-model="createdTreeRoute" />
                      </div>
                    </div>
                  </div>
                  <!-- End Route -->
                  <!-- Vessel -->
                  <div v-if="tab == 'Vessel'" class="rASlAP nLoI_Y TQABDn">
                    <div class="VTkRN8 J_ckmS LcN9e5">
                      <div class="GIgiMg">
                        <Vessel v-model="data" />
                      </div>
                    </div>
                  </div>

                  <!-- End Vessel -->
                  <!-- Containers -->
                  <div v-if="tab == 'Containers'" class="rASlAP nLoI_Y TQABDn">
                    <div class="VTkRN8 J_ckmS">
                      <div class="VhgUhV">
                        <Containers v-model="data" />
                      </div>
                    </div>
                  </div>
                  <!-- End Container -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="B36fNw igzvVg">
          <Map :data="data" />
        </div>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import ClickOutside from "vue-click-outside";
import error from "@/assets/images/pages/error.svg";
import errorDark from "@/assets/images/pages/error-dark.svg";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import RouteSeaRates from "./BL/Router.vue";
import Vessel from "./BL/Vessel.vue";
import Containers from "./BL/Containers.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Map from "./Map.vue";
export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
    RouteSeaRates,
    Vessel,
    Containers,
    Map,
  },
  directives: {
    ClickOutside,
  },
  props: {
    request_quotation: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      moment,
      error,
      errorDark,
      downImg: require("@/assets/images/pages/error.svg"),
      showDrop: false,
      tab: "Route",
      data: null,
      search: "",
    };
  },
  mounted() {},
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties

        return this.error;
      }
      return this.errorDark;
    },
    createdTreeRoute() {
      const events = this.data?.containers[0]?.events;
      /* 1  group location   */
      const group_location = events.reduce((acc, cur) => {
        const { location } = cur;
        if (!acc[location]) {
          acc[location] = [];
        }
        acc[location].push(cur);
        return acc;
      }, {});
      /* 2  group_location find location == id của locations group child   */
      const tree = [];
      for (const [key, value] of Object.entries(group_location)) {
        const numericKey = Number(key);
        const parent = this.data.locations.find(
          (item) => item.id === numericKey
        );

        if (parent) {
          tree.push({
            ...parent,
            children: value,
          });
        }
      }

      return tree;
    },
  },
  methods: {
    onSearch() {
      if (!this.search) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập thông tin tìm kiếm",
            icon: "CheckSquareIcon",
            variant: "danger",
          },
        });

        return;
      }

      useJwt
        .get("wr1?objectType=SeaRateTracking", {
          params: {
            search: { id: this.request_quotation.id, booking_no: this.search },
          },
        })
        .then((response) => {
          console.log(JSON.stringify(response.data.result.data));
          this.data = response.data.result.data;
        });
    },
  },
};
</script>
<style>
#app-container {
  --rem-base: 10px;
  --tc-palette-black: #000;
  --tc-palette-gray-100: #f8f9fd;
  --tc-palette-gray-200: #eff1f6;
  --tc-palette-gray-300: #e0e4ec;
  --tc-palette-gray-400: #c9cfdb;
  --tc-palette-gray-600: #9ea9b9;
  --tc-palette-gray-800: #6e7e92;
  --tc-palette-gray-900: #000c37;
  --tc-palette-blue: #28938d;
  --tc-palette-blue-light: #f5f6ff;
  --tc-palette-red: #f52c5c;
  --tc-palette-red-light: #fff2f5;
  --tc-palette-teal: #02bcb1;
  --tc-palette-teal-light: #ddf8f6;
  --tc-palette-purple: #5864ff;
  --tc-palette-white: #fff;
  --tc-palette-hover: #e5e8ff;
  --tc-palette-future-accent: #f2f9ff;
  --tc-palette-accent: #28938d;
  --tc-default-text-color: var(--tc-palette-gray-800);
  --tc-palette-blue-dark: #0139ff;
  --tc-gradient-undefined: linear-gradient(
    265.89deg,
    #f3e7e9 -7.22%,
    #e3eeff 107.3%
  );
  --tc-gradient-error: linear-gradient(59.74deg, #ff3b57, #892168);
  --tc-gradient-warning: linear-gradient(59.74deg, #ffab1d, #f8501c);
  --tc-gradient-success: linear-gradient(59.74deg, #13c549, #0dbbbb);
  --tc-gradient-active-tab: linear-gradient(
    82.61deg,
    #33ceff -47.11%,
    var(--tc-palette-blue-dark) 105.57%
  );
  --tc-primary-font: Montserrat, system-ui, -apple-system, Segoe UI, Roboto,
    Ubuntu, Cantarell, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol, Noto Color Emoji;
  --tc-font-awesome-6-pro: Font Awesome 6 Pro;
  --tc-shadow-1: 0 calc(var(--rem-base) * 1.5) calc(var(--rem-base) * 3)
    rgba(58, 112, 191, 0.15);
  --tc-shadow-2: 0 calc(var(--rem-base) * 0.4) calc(var(--rem-base) * 1.5)
    rgba(58, 112, 191, 0.1);
  --tc-transition-duration: 0.2s;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--tc-default-text-color);
  display: flex;
  font-family: var(--tc-primary-font);
  font-size: calc(var(--rem-base) * 1.6);
  font-style: normal;
  height: 900px;
  line-height: calc(var(--rem-base) * 2.4);
  max-height: 900px;
  min-height: 560px;
  position: relative;
}
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";

.app-root {
  flex-grow: 1;
}
.jNVSgr {
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.sTC0fR {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: calc(var(--rem-base) * 1.6);
  transition: all 0.2s linear;
  width: calc(var(--rem-base) * 61.2);
  border: 3px solid var(--tc-palette-accent);
  border-radius: calc(var(--rem-base) * 4);
}

.r8H33s {
  flex: 0 0 5%;
  width: 100%;
  .AGjDmN {
    border: 1px solid var(--tc-palette-accent);
    align-items: center;
    background: var(--tc-palette-white);
    border-radius: calc(var(--rem-base) * 10);
    box-shadow: var(--tc-shadow-2);
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    padding: calc(var(--rem-base) * 0.4);
    .mb5u3c {
      flex-grow: 1;
      padding-right: calc(var(--rem-base) * 0.4);
      input {
        border: calc(var(--rem-base) * 0.1) solid transparent;
        border-radius: calc(var(--rem-base) * 10);
        box-sizing: border-box;
        font-family: var(--tc-primary-font);
        font-size: calc(var(--rem-base) * 1.8);
        font-weight: 500;
        height: calc(var(--rem-base) * 5.2);
        line-height: calc(var(--rem-base) * 2);
        overflow: hidden;
        padding-left: calc(var(--rem-base) * 1.6);
        text-overflow: ellipsis;
        transition: all 0.2s;
        width: 100%;

        &:focus {
          border-color: #fff;
          box-shadow: 0 0 0 calc(var(--rem-base) * 0.2) #fff;
          outline: 0;
        }
      }
    }
    button {
      height: calc(var(--rem-base) * 5.2);
      width: calc(var(--rem-base) * 5.2);
      svg {
        height: calc(var(--rem-base) * 2.2);
        width: calc(var(--rem-base) * 2.2);
        color: var(--tc-palette-white);
        fill: #fff;
      }
    }
  }
  .cewbX8 {
    align-items: center;
    display: flex;
    justify-content: center;
  }
}

.WTsBDL {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: calc(var(--rem-base) * 0.1) solid transparent;
  border-radius: calc(var(--rem-base) * 10);
  cursor: pointer;
  font-size: calc(var(--rem-base) * 1.4);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 2.2);
  outline: none;
  padding: 0;
  &.DX8c49 {
    background-color: var(--tc-palette-accent);
    color: var(--tc-palette-white);
    transition-duration: var(--tc-transition-duration);
    transition-property: background-color;
  }
}

.en0Ha_ {
  font-size: calc(var(--rem-base) * 2);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 3);
  padding: calc(var(--rem-base) * 0.4) calc(var(--rem-base) * 1.6);
}
.wozMv1 {
  bottom: calc(var(--rem-base) * 6.5);
  display: none;
  justify-content: center;
  left: 50%;
  margin: calc(var(--rem-base) * 1.5) 0;
  position: relative;
  transform: translate(-50%);
  z-index: 14;
}

.u71Ug3 {
  align-items: center;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: var(--tc-palette-gray-900);
  display: flex;
  font-size: calc(var(--rem-base) * 1.4);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 1.4);
  margin: 0;
  padding: 0;
}
.ahH3dr {
  margin-right: 4px;
  transform: rotate(180deg);
}

.TWpeI4 {
  align-items: center;
  display: flex;
  min-height: calc(var(--rem-base) * 4.5);
  padding: 0 calc(var(--rem-base) * 0.3);
}

.W7yOGL {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.OZ_R4c {
  flex-grow: 1;
  overflow-y: auto;
  scrollbar-color: #ddd transparent;
}
.u4BptP {
  background: var(--tc-palette-white);
  border-radius: calc(var(--rem-base) * 0.6);
  box-shadow: var(--tc-shadow-2);
  color: var(--tc-palette-gray-900);
  min-height: calc(var(--rem-base) * 13.6);
  padding: calc(var(--rem-base) * 1.4) calc(var(--rem-base) * 1.6);
}

.l2VQom {
  align-items: baseline;
  display: flex;
}

.HMVUKi,
.LeIfXT {
  font-size: calc(var(--rem-base) * 1.4);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 2.2);
}
.HMVUKi {
  margin-left: calc(var(--rem-base) * 0.5);
}

.LeIfXT {
  color: var(--tc-palette-gray-600);
}
.l2VQom .ZQiFhL {
  margin-right: auto;
}
.PJhkJh {
  align-items: center;
  display: flex;
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 1.6);
  .A7lpjs {
    cursor: pointer;
    margin-left: calc(var(--rem-base) * 0.9);
  }
}
.w3nFNe {
  background-color: var(--tc-palette-purple);
  border-radius: calc(var(--rem-base) * 1);
  color: var(--tc-palette-white);
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 1.4);
  padding: calc(var(--rem-base) * 0.4) calc(var(--rem-base) * 1);
  text-align: center;
  text-transform: uppercase;
}
.w3nFNe.rmT1SZ {
  background-color: #ffefc7;
  color: #222;
  font-weight: 900;
}
.gU7H2r,
.mNSdiZ.ZwrEze {
  z-index: 2;
}

.mNSdiZ {
  margin-left: calc(var(--rem-base) * 0.9);
}

.CiXy7G {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: calc(var(--rem-base) * 1.3);
}

.u4BptP {
  background: var(--tc-palette-white);
  border-radius: calc(var(--rem-base) * 0.6);
  box-shadow: var(--tc-shadow-2);
  color: var(--tc-palette-gray-900);
  min-height: calc(var(--rem-base) * 13.6);
  padding: calc(var(--rem-base) * 1.4) calc(var(--rem-base) * 1.6);
}

.DB6l5z {
  font-size: calc(var(--rem-base) * 1.6);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 1.8);
}

.u0XzuN.UyUQn0 {
  flex-shrink: 0;
  height: calc(var(--rem-base) * 2.56);
  width: 100%;
}

.u0XzuN,
.u0XzuN .hkD4KS {
  align-items: center;
  display: flex;
  position: relative;
}
.u0XzuN {
  animation: appearance 0.4s ease-in-out forwards;
  justify-content: flex-start;
  opacity: 1;
}

.u0XzuN.pZIPN_ .hkD4KS {
  background-color: var(--tc-palette-accent);
}

.u0XzuN .hkD4KS {
  border-radius: calc(var(--rem-base) * 1.2);
  height: calc(var(--rem-base) * 1.2) !important;
  justify-content: center;
  min-height: calc(var(--rem-base) * 1.2) !important;
  min-width: calc(var(--rem-base) * 1.2) !important;
  overflow: hidden;
  width: calc(var(--rem-base) * 1.2) !important;
  z-index: 8;
}

.u0XzuN.pZIPN_ .hkD4KS:after {
  background-color: #fff;
}
.u0XzuN .hkD4KS:after {
  border-radius: calc(var(--rem-base) * 0.4);
  content: "";
  height: calc(var(--rem-base) * 0.4);
  left: calc(50% - cRem(2, true));
  position: absolute;
  top: calc(50% - cRem(2, true));
  width: calc(var(--rem-base) * 0.4);
}

.u0XzuN.UyUQn0 .Ocb7IW.Do4DFw {
  min-width: calc(var(--rem-base) * 4.8);
}

.u0XzuN.UyUQn0 .Ocb7IW {
  height: calc(var(--rem-base) * 0.3);
}

.u0XzuN .Ocb7IW.Do4DFw {
  align-items: center;
  background-color: var(--tc-palette-accent);
  display: flex;
  justify-content: flex-end;
  left: 0;
  position: relative;
}

.u0XzuN .Ocb7IW {
  transition: all 0.4s;
}

.l2VQom {
  align-items: baseline;
  display: flex;
}

@media (min-width: 601px) {
  .esnUFS {
    min-width: 63%;
  }
}

.esnUFS {
  align-items: center;
  display: flex;
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 2);
  margin-right: auto;
}

.X6ICUu {
  color: var(--tc-palette-gray-900);
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 1.8);
  text-align: right;
}
.HVrMNK {
  margin-top: calc(var(--rem-base) * 2);
}
.HVrMNK {
  align-items: flex-start;
  flex-grow: 1;
  overflow-y: hidden;
}
.l2VQom {
  align-items: baseline;
  display: flex;
}

.C4xvpO {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  width: 100%;
}
.oiKIxr {
  border-bottom: 1px solid var(--tc-palette-gray-200);
  margin-bottom: calc(var(--rem-base) * 2);
}
.rASlAP {
  align-items: center;
  display: flex;
}
.vYiyP7 {
  background: #fff;
}

.cF7936 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: none;
  border-radius: calc(var(--rem-base) * 0.8);
  cursor: pointer;
  font-family: var(--tc-primary-font);
  font-size: calc(var(--rem-base) * 1.4);
  font-style: normal;
  font-weight: 500;
  letter-spacing: calc(var(--rem-base) * 0.1);
  line-height: calc(var(--rem-base) * 1.6);
  outline: none;
  padding: calc(var(--rem-base) * 0.6) 0;
  position: relative;
}
button,
input,
select,
textarea {
  color: #222;
}
.cF7936 + .cF7936 {
  margin-left: calc(var(--rem-base) * 4);
}
.cF7936.OKYBET .MyNzRc {
  color: var(--tc-palette-accent);
}
.MyNzRc {
  color: var(--tc-palette-gray-800);
  display: block;
  text-align: left;
  transition: color 0.1s;
}
.cF7936 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: none;
  border-radius: calc(var(--rem-base) * 0.8);
  cursor: pointer;
  font-family: var(--tc-primary-font);
  font-size: calc(var(--rem-base) * 1.4);
  font-style: normal;
  font-weight: 500;
  letter-spacing: calc(var(--rem-base) * 0.1);
  line-height: calc(var(--rem-base) * 1.6);
  outline: none;
  padding: calc(var(--rem-base) * 0.6) 0;
  position: relative;
}

.cF7936.OKYBET:after {
  opacity: 1;
  visibility: visible;
}
.cF7936:after {
  background-color: var(--tc-palette-accent);
  bottom: calc(var(--rem-base) * -0.2);
  content: "";
  display: block;
  height: calc(var(--rem-base) * 0.2);
  left: 50%;
  opacity: 0;
  position: absolute;
  transform: translate(-50%, -50%);
  transition-delay: 0.1s;
  transition-property: opacity, visibility;
  visibility: hidden;
  width: calc(var(--rem-base) * 1.6);
}

.TQABDn {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 0;
  overflow-y: auto;
  scrollbar-color: #ddd transparent;
  width: 100%;
}
.u4BptP {
  background: var(--tc-palette-white);
  border-radius: calc(var(--rem-base) * 0.6);
  box-shadow: var(--tc-shadow-2);
  color: var(--tc-palette-gray-900);
  min-height: calc(var(--rem-base) * 13.6);
  padding: calc(var(--rem-base) * 1.4) calc(var(--rem-base) * 1.6);
}
.J_ckmS {
  flex-grow: 1;
}
.VTkRN8 {
  animation: fade-in-animation 0.2s ease-in-out forwards;
  width: 100%;
  z-index: 1;
}
.LAM7Hq {
  font-style: normal;
  padding-left: calc(var(--rem-base) * 2.5);
}
.LL_VGj {
  grid-gap: 0 calc(var(--rem-base) * 2);
  display: grid;
  font-style: normal;
  grid-template-columns: minmax(35%, 65%) 1fr;
}

.RxDe5g {
  color: var(--tc-palette-accent);
  font-size: calc(var(--rem-base) * 1.4);
  font-weight: 600;
  grid-column: 1/-1;
  line-height: calc(var(--rem-base) * 1.6);
  position: relative;
  &:before {
    background-color: var(--tc-palette-accent);
    height: calc(var(--rem-base) * 1.2);
    left: calc(var(--rem-base) * -2.1);
    width: calc(var(--rem-base) * 1.2);
  }
  &:after {
    background-color: var(--tc-palette-white);
    height: calc(var(--rem-base) * 0.4);
    left: calc(var(--rem-base) * -1.7);
    width: calc(var(--rem-base) * 0.4);
  }
  &:after,
  &:before {
    border-radius: 50%;
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}

.ulODKO {
  display: flex;
  flex-direction: column;
}
.bDbG1b,
.o9dT5G {
  color: var(--tc-palette-gray-900);
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 1.4);
  min-height: calc(var(--rem-base) * 1.4);
}
.bDbG1b {
  margin-top: calc(var(--rem-base) * 1.2);
}
.o9dT5G {
  word-wrap: break-word;
  position: relative;
}
.o9dT5G.UPwwP4:before {
  background-color: var(--tc-palette-accent);
  height: calc(100% + var(--rem-base) * 1.4);
  top: calc(var(--rem-base) * -1.4);
}
.o9dT5G.Xe1WSs:after,
.o9dT5G:before {
  background-color: transparent;
  content: "";
  display: block;
  left: calc(var(--rem-base) * -1.6);
  position: absolute;
  width: calc(var(--rem-base) * 0.2);
  z-index: -1;
}
.bDbG1b,
.o9dT5G {
  color: var(--tc-palette-gray-900);
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 1.4);
  min-height: calc(var(--rem-base) * 1.4);
}
.o9dT5G.cYtFlT:before {
  height: calc(
    100% + var(--rem-base) * 1.2 + var(--rem-base) * 2.4 + var(--rem-base) * 0.4
  );
}
.LL_VGj + .LL_VGj {
  margin-top: calc(var(--rem-base) * 2.4);
}
.LL_VGj {
  grid-gap: 0 calc(var(--rem-base) * 2);
  display: grid;
  font-style: normal;
  grid-template-columns: minmax(35%, 65%) 1fr;
}
.ulODKO {
  display: flex;
  flex-direction: column;
}
.bDbG1b,
.o9dT5G {
  color: var(--tc-palette-gray-900);
  font-size: calc(var(--rem-base) * 1.2);
  font-weight: 500;
  line-height: calc(var(--rem-base) * 1.4);
  min-height: calc(var(--rem-base) * 1.4);
}
.bDbG1b {
  margin-top: calc(var(--rem-base) * 1.2);
}
.o9dT5G .CsxG4o {
  display: block;
  left: calc(var(--rem-base) * -2.3);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.J_ckmS {
  flex-grow: 1;
}
.VTkRN8 {
  animation: fade-in-animation 0.2s ease-in-out forwards;
  width: 100%;
  z-index: 1;
}

.B36fNw {
  background-color: var(--tc-palette-gray-400);
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  text-align: right;
}
.o9dT5G.efpa_k.cYtFlT:before {
  height: calc(100% + 12px);
}

.LcN9e5 {
  display: flex;
  flex-direction: column;
}
.GIgiMg {
  flex-grow: 1;
  scrollbar-color: #ddd transparent;
}
.GIgiMg .Ka3O3w {
  display: flex;
}
.GIgiMg .I4TWtc,
.GIgiMg .yKQVPS {
  font-size: calc(var(--rem-base) * 1.4);
  line-height: calc(var(--rem-base) * 2.5);
}
.GIgiMg .yKQVPS {
  font-weight: 600;
  width: calc(var(--rem-base) * 12);
  color: var(--tc-palette-accent);
}
.GIgiMg .Ka3O3w + .Ka3O3w {
  margin-top: calc(var(--rem-base) * 1.6);
}
.J9alP4 {
  color: var(--tc-palette-gray-900);
  cursor: pointer;
  display: flex;
  font-size: calc(var(--rem-base) * 1.4);
  font-weight: 600;
  line-height: calc(var(--rem-base) * 1.8);
  padding: calc(var(--rem-base) * 1.5) 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.ZvlSEi {
  padding-bottom: calc(var(--rem-base) * 1.5);
  padding-left: calc(var(--rem-base) * 2.5);
}
.LbxpaC {
  border-bottom: 1px solid var(--tc-palette-gray-200);
}
.TQABDn::-webkit-scrollbar,
.TQABDn::-webkit-scrollbar-track-piece {
  background: transparent;
  width: 8px;
}
.TQABDn::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 10px;
}
.TQABDn::-webkit-scrollbar,
.TQABDn::-webkit-scrollbar-track-piece {
  background: transparent;
  width: 8px;
}
.ubJc5M.wcPNG_ {
  transform: rotate(-90deg);
}
.ubJc5M {
  margin-left: auto;
  transform: rotate(90deg);
  transition: transform var(--tc-transition-duration);
}
.esnUFS .dqZ0ad + .dqZ0ad {
  margin-left: calc(var(--rem-base) * 1.6);
}
.GIgiMg .GQN9PQ:not(:last-child) {
  border-bottom: calc(var(--rem-base) * 0.1) solid var(--tc-palette-gray-200);
}
.GIgiMg .GQN9PQ:last-child {
  padding-bottom: 0;
}

.GIgiMg .GQN9PQ {
  padding: calc(var(--rem-base) * 2) 0;
}
</style>
